import axios from 'axios';
import { BASE_URL, JWT_APP_ID } from '../../config/URL';
import { generateErrorDetail } from '../../utils';
import { showToastNotif } from './notification';

// const URL = '/catalog/v1.0/watchlist';
const URLS = '/catalog/v1.0/watchlists';

export const getMyList = (page, perPage) => async (dispatch, getState) => {
  const state = getState();
  dispatch({
    type: 'GET_MY_LIST_PROCESS',
  });

  try {
    const res = await axios.get(
      `${BASE_URL}${URLS}?page=${page}&perPage=${perPage}`,
      {
        headers: {
          Authorization: state.auth.token,
          'Cloudfront-JWT-AppId': JWT_APP_ID,
          'cloudfront-jwt-profileId': state.auth.user.profile.id,
        },
      }
    );
    dispatch({
      type: 'GET_MY_LIST_SUCCESS',
      payload: {
        ...res.data,
      },
      page,
    });
  } catch (err) {
    const errorData = generateErrorDetail(err);
    dispatch(
      showToastNotif('error', 'Some error occured, please refresh the page!')
    );
    dispatch({
      type: 'GET_MY_LIST_FAILED',
      payload: errorData,
    });
  }
};

export const addToMyList = (id, type) => async (dispatch, getState) => {
  const state = getState();
  try {
    let url = `${BASE_URL}/catalog/v1.0/watchlists`;
    await axios.post(
      url,
      {
        itemId: id,
        itemType: type,
      },
      {
        headers: {
          Authorization: state.auth.token,
          'Cloudfront-JWT-AppId': JWT_APP_ID,
          'cloudfront-jwt-profileId': state.auth.user.profile.id,
        },
      }
    );
    dispatch({
      type: 'ADD_LIST_SUCCESS',
    });
  } catch (err) {
    dispatch({
      type: 'ADD_LIST_ERROR',
      err: err?.response?.data?.error,
    });
  }
};

export const getListStatus = (id, type) => async (dispatch, getState) => {
  const state = getState();
  try {
    let url = `${BASE_URL}/catalog/v1.0/watchlists/getStatusByItemId?itemId=${id}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: state.auth.token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
        'cloudfront-jwt-profileId': state.auth.user.profile.id,
      },
    });
    dispatch({
      type: 'SET_LIST_STATUS',
      payload: res?.data?.data?.addedToMyList,
    });
  } catch (err) {
    dispatch({
      type: 'ADD_LIST_ERROR',
      err: err,
    });
  }
};

export const removeFromMyList = (id) => async (dispatch, getState) => {
  const state = getState();
  try {
    let url = `${BASE_URL}/catalog/v1.0/watchlist/${id}`;
    await axios.delete(url, {
      headers: {
        Authorization: state.auth.token,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
        'cloudfront-jwt-profileId': state.auth.user.profile.id,
      },
    });
    dispatch({
      type: 'REMOVE_LIST_SUCCESS',
    });
  } catch (err) {
    dispatch({
      type: 'REMOVE_LIST_ERROR',
      err: err,
    });
  }
};
